import { render } from "./GroupChatsWrapper.vue?vue&type=template&id=27aa5bc2&scoped=true"
import script from "./GroupChatsWrapper.vue?vue&type=script&lang=js"
export * from "./GroupChatsWrapper.vue?vue&type=script&lang=js"

import "./GroupChatsWrapper.vue?vue&type=style&index=0&id=27aa5bc2&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27aa5bc2"]])

export default __exports__